import React from 'react';
import { Input } from 'reactstrap';

const TextAreaControl = (props) => {
  let {labelText, value, onChange, name, visible} = props;
  let isVisible = visible === undefined ? true : visible;
  return isVisible ? (
    <div className="form-group row">
      <label className="col-2 col-sm-3 form-control-label" htmlFor={name}>{labelText}</label>
      <div className="col-8 col-sm-9">
        <textarea
          rows="6" cols="20"
          type="text"
                  className="form-control"
                  placeholder={labelText}
                  value={value == null ? '' : value}
                  onChange={onChange}
                  name={name}
        />
      </div>
    </div>
  ) : null;
};

export default TextAreaControl;